import { rem } from 'polished'
import * as React from 'react'

import { MatchMedia } from '../../MatchMedia'
import { styled } from '../../theme'
import fullLogo from './imgs/full_logo.svg'
import helvetiLogo_de from './imgs/helvetia_logo_de.svg'
import helvetiLogo_en from './imgs/helvetia_logo_en.svg'
import helvetiLogo_es from './imgs/helvetia_logo_es.svg'
import helvetiLogo_fr from './imgs/helvetia_logo_fr.svg'
import helvetiLogo_it from './imgs/helvetia_logo_it.svg'
import iconLogo from './imgs/icon_logo.svg'

const helvetiaLogo = {
  de: helvetiLogo_de,
  fr: helvetiLogo_fr,
  it: helvetiLogo_it,
  en: helvetiLogo_en,
  es: helvetiLogo_es,
}

const FullLogo = styled.img.attrs({})<{ src: string }>`
  src: ${p => p.src};
  height: 100%;
  width: 425px;
  display: 'flex';
  justify-self: 'flex-end';
  align-self: 'flex-end';

  max-width: 100%;
  max-height: 70px;
`

const BigLogo = styled.img.attrs({
  src: fullLogo,
})`
  width: ${rem(170)};
  height: ${rem(40)};
`

const IconLogo = styled.img.attrs({
  src: iconLogo,
})`
  width: ${rem(39)};
  height: ${rem(40)};
`

interface Props {
  lang: string
}

const Logo: React.SFC<Props> = ({ lang }) => {
  const src = helvetiaLogo[lang]
  return (
    <>
      <MatchMedia onlyMobile>
        <IconLogo />
      </MatchMedia>
      <MatchMedia onlyTabletAndDesktop>
        <BigLogo />
      </MatchMedia>
      <MatchMedia largeDesktop>
        <FullLogo src={src} />
      </MatchMedia>
    </>
  )
}

export default Logo
